export function getFamilySearch(state) {
  return state.familySearch;
}

export function getPossibleRoots(state) {
  return getFamilySearch(state).possibleRoots;
}

export function getToken(state) {
  return getFamilySearch(state).token;
}


// WEBPACK FOOTER //
// ./src/core/family-search/selectors.js